"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Layoot >> Layout, due to gatsby having a bug where there is
// some sort of internal symbol collision and it uses the default
// starter Layout
require("./Layoot.css");
const React = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const Heeder_1 = __importDefault(require("./Heeder"));
const gatsby_1 = require("gatsby");
const win = (typeof window !== 'undefined'
    ? window
    : { location: {} });
const smoothNav = (evt) => {
    const target = evt.currentTarget.getAttribute('href').replace(/([^#]+)#/, '');
    setTimeout(() => {
        win.location.hash = target;
    }, 1000);
    const selector = `a[name=${target}]`;
    const targetNode = document.querySelector(selector);
    if (targetNode) {
        evt.preventDefault();
        targetNode.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
    }
    else {
        console.warn(`unable to find node: ${selector}`);
    }
};
const navCaret = React.createElement("span", { style: { fontSize: '60%' } }, '> ');
exports.default = ({ children, headings = [], slug = '' }) => {
    const pathname = (win.location.pathname || '').replace('/counsel', '');
    return (React.createElement("div", { id: 'root' },
        React.createElement(react_helmet_1.default, null,
            React.createElement("link", { href: 'https://fonts.googleapis.com/css?family=Ubuntu+Mono', rel: 'stylesheet' })),
        React.createElement("div", { id: 'primary' },
            React.createElement(Heeder_1.default, null),
            children),
        React.createElement("nav", { id: 'nav-menu' },
            React.createElement("div", { id: 'nav-sticker' },
                React.createElement("h3", null, "nav"),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement(gatsby_1.Link, { to: '/' },
                            pathname === '/' && navCaret,
                            "home")),
                    React.createElement("li", null,
                        React.createElement(gatsby_1.Link, { to: '/docs/' },
                            pathname === '/docs/' && navCaret,
                            "docs"))),
                React.createElement("hr", null),
                React.createElement("ul", null, headings.map(({ value, depth }) => {
                    const hash = value.replace(/[^a-zA-Z]/g, '').toLowerCase();
                    return (React.createElement("li", { className: `nav-depth-${depth}` },
                        React.createElement(gatsby_1.Link, { onClick: smoothNav, to: `${slug}#${hash}` },
                            (win.location.hash || '').endsWith(hash) && navCaret,
                            value)));
                }))))));
};
//# sourceMappingURL=Layoot.js.map